<style lang="less">
    @import "../../../styles/table.less";
</style>
<template>
    <div class="search">
        <Row>
            <Col>
                <Card title="线下课程">
                    <Row @keydown.enter.native="handleSearch">
                        <Form ref="searchForm" :model="searchForm" inline :label-width="70">
                            <Form-item label="标题" prop="courseTitle">
                                <Input type="text" v-model="searchForm.courseTitle" placeholder="请输入标题" clearable style="width: 200px"/>
                            </Form-item>
                            <Form-item label="讲师名称" prop="userName">
                                <Input type="text" v-model="searchForm.userName" placeholder="请输入讲师名称" clearable style="width: 200px"/>
                            </Form-item>
                            <span v-if="drop">
                                <Form-item label="创建时间">
                                  <DatePicker v-model="selectDate" type="daterange" split-panels format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
                                </Form-item>
                            </span>
                            <Form-item style="margin-left:-35px;" class="br">
                                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                                <Button @click="handleReset">重置</Button>
                                <a class="drop-down" @click="dropDown">{{dropDownContent}}
                                    <Icon :type="dropDownIcon"></Icon>
                                </a>
                            </Form-item>
                        </Form>
                    </Row>
                    <Row class="operation">
                        <Button @click="add" type="primary" icon="md-add">新建课程</Button>
                        <Button @click="delAll" icon="md-trash">批量删除</Button>
                        <Button @click="getDataList" icon="md-refresh">刷新</Button>
                        <circleLoading v-if="operationLoading"/>
                    </Row>
                    <Row>
                        <Alert show-icon>
                            已选择 <span class="select-count">{{selectCount}}</span> 项
                            <a class="select-clear" @click="clearSelectAll">清空</a>
                        </Alert>
                    </Row>
                    <Row>
                        <Table :loading="loading" border :columns="columns"  size="small"  :data="data" sortable="custom" @on-sort-change="changeSort" @on-selection-change="showSelect" ref="table"></Table>
                    </Row>
                    <Row type="flex" justify="end" class="page">
                        <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
                    </Row>
                </Card>
            </Col>
        </Row>
        <offcourse-drawer ref="offCourseDrawer"></offcourse-drawer>
    </div>
</template>

<script>
    import circleLoading from "../../my-components/circle-loading.vue";
    import {offCourseList,delOffCourse,setOffCourseStatus,setApplyType,setOffCourseIndex} from "@/api/bus";
    import offcourseDrawer from "./offcourse-drawer";
    export default {
        name: "offcourse-manage",
        components: {
            offcourseDrawer,
            circleLoading
        },
        data() {
            return {
                loading: false, // 表单加载状态
                operationLoading: false,
                drop: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                searchForm: {
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "createTime", // 默认排序字段
                    order: "desc", // 默认排序方式
                    courseTitle: "",
                    userName: "",
                    startDate: "",
                    endDate: ""
                },
                selectDate: null, //选择日期绑定modal
                columns: [
                    {
                        type: "selection",
                        width: 60,
                        align: "center"
                    },
                    {
                        type: "index",
                        width: 60,
                        align: "center"
                    },
                    {
                        title: "课程标题",
                        key: "courseTitle",
                        ellipsis:true,
                        tooltip:true,
                        width: 220,
                        sortable: true
                    }, {
                        title: "封面图",
                        key: "courseImage",
                        width: 120,
                        align: "center",
                        render: (h, params) => {
                            return h("img", {
                                attrs: {
                                    src: params.row.courseImage,
                                    alt: "加载图片失败"
                                },
                                style: {
                                    cursor: "pointer",
                                    width: "80px",
                                    height: "50px",
                                    margin: "5px 0",
                                    "object-fit": "contain"
                                },
                                on: {
                                    click: () => {

                                    }
                                }
                            });

                        }
                    },
                    {
                        title: "上课地址",
                        key: "courseAddress",
                        width: 170,
                        ellipsis:true,
                        tooltip:true,
                        sortable: true
                    },
                    {
                        title: "报名费",
                        key: "coursePrice",
                        width: 100,
                        sortable: true
                    },
                    {
                        title: "报名人数",
                        key: "enrollNum",
                        width: 120,
                        sortable: true,
                        render: (h, params) => {

                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "green"
                                            }
                                        },
                                        params.row.nowNum+'/'+params.row.enrollNum
                                    )
                                ]);
                        }

                    },
                    {
                        title: "截至报名时间",
                        key: "deadline",
                        width: 170,
                        sortable: true
                    },
                    {
                        title: "课程状态",
                        key: "courseStatus",
                        width: 120,
                        render: (h, params) => {
                            return h(
                                "Select",
                                {
                                    props: {
                                        value: params.row.courseStatus
                                    },
                                    on: {
                                        "on-change": v => {
                                            this.setOffCourseStatus(params.row, v);
                                        }
                                    }
                                },
                                [
                                    h(
                                        "Option",
                                        {
                                            props: {
                                                value: 0
                                            }
                                        },
                                        "未发布"
                                    ),
                                    h(
                                        "Option",
                                        {
                                            props: {
                                                value: 1
                                            }
                                        },
                                        "已发布"
                                    ),
                                    h(
                                        "Option",
                                        {
                                            props: {
                                                value: 2
                                            }
                                        },
                                        "已下架"
                                    )
                                ]
                            );
                        }
                    },
                    {
                        title: "报名状态",
                        key: "applyType",
                        width: 120,
                        render: (h, params) => {
                            return h(
                                "Select",
                                {
                                    props: {
                                        value: params.row.applyType
                                    },
                                    on: {
                                        "on-change": v => {
                                            this.setApplyType(params.row, v);
                                        }
                                    }
                                },
                                [
                                    h(
                                        "Option",
                                        {
                                            props: {
                                                value: 0
                                            }
                                        },
                                        "未开始"
                                    ),
                                    h(
                                        "Option",
                                        {
                                            props: {
                                                value: 1
                                            }
                                        },
                                        "进行中"
                                    ),
                                    h(
                                        "Option",
                                        {
                                            props: {
                                                value: 2
                                            }
                                        },
                                        "已截止"
                                    )
                                ]
                            );
                        }
                    },
                    {
                        title: "首页推荐",
                        key: "recomIndex",
                        width: 100,
                        sortable: true,
                        render: (h, params) => {
                            return h(
                                "i-switch",
                                {
                                    props: {
                                        value: params.row.recomIndex,
                                        size: "large",
                                        "true-value": 1,
                                        "false-value": 0
                                    },
                                    on: {
                                        "on-change": v => {
                                            this.setOffCourseIndex(params.row, v);
                                        }
                                    }
                                },
                                [
                                    h("span", {slot: "open"}, "是"),
                                    h("span", {slot: "close"}, "否")
                                ]
                            );
                        }
                    },
                    {
                        title: "创建时间",
                        key: "createTime",
                        width: 170,
                        sortable: true
                    },
                    {
                        title: "操作",
                        key: "action",
                        width: 200,
                        align: "center",
                        fixed: "right",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row);
                                            }
                                        }
                                    },
                                    "编辑"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small"
                                        },
                                        on: {
                                            click: () => {
                                                this.remove(params.row);
                                            }
                                        }
                                    },
                                    "删除"
                                )
                            ]);
                        }
                    }],
                data: [], // 表单数据
                total: 0 // 表单数据总数
            }
        },
        methods: {
            init() {
                this.getDataList();
            },
            getDataList() {
                this.loading = true;
                offCourseList(this.searchForm).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.data = res.data.rows;
                        this.total = res.data.total;
                    }
                });
            },
            //添加直播
            add() {
                let query = {type: 0}
                this.$refs.offCourseDrawer.showDrawer(query);
            },
            edit(v) {
                let query = { type: 1, id: v.id, backRoute: this.$route.name };
                this.$refs.offCourseDrawer.showDrawer(query);
            },
            remove(v) {
                this.$Modal.confirm({
                    title: "确认删除",
                    content: "您确认要删除?",
                    onOk: () => {
                        delOffCourse(v.id).then(res => {
                            if (res.status === true) {
                                this.$Message.success("删除成功");
                                this.getDataList();
                            }
                        });
                    }

                });
            },
            //设置课程推荐状态
            setOffCourseStatus(row,v){
                let params={
                    id:row.id,
                    courseStatus:v
                }
                setOffCourseStatus(params).then(res => {
                    if (res.status === true) {
                        this.$Message.success(res.info);
                    }
                });;
            },
            //设置首页推荐
            setOffCourseIndex(row,v){
                let params={
                    id:row.id,
                    recomIndex:v
                }
                setOffCourseIndex(params).then(res => {
                    if (res.status === true) {
                        this.$Message.success(res.info);
                    }
                });;
            },
            //设置课程报名状态
            setApplyType(row,v){
                let params={
                    id:row.id,
                    applyType:v
                }
                setApplyType(params).then(res => {
                    if (res.status === true) {
                        this.$Message.success(res.info);
                    }
                });;
            },
            handleSearch() {
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.getDataList();
            },
            handleReset() {
                this.$refs.searchForm.resetFields();
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.selectDate = null;
                this.searchForm.startDate = "";
                this.searchForm.endDate = "";
                // 重新加载数据
                this.getDataList();
            },
            dropDown() {
                if (this.drop) {
                    this.dropDownContent = "展开";
                    this.dropDownIcon = "ios-arrow-down";
                } else {
                    this.dropDownContent = "收起";
                    this.dropDownIcon = "ios-arrow-up";
                }
                this.drop = !this.drop;
            },
            selectDateRange(v) {
                if (v) {
                    this.searchForm.startDate = v[0];
                    this.searchForm.endDate = v[1];
                }
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            showSelect(e) {
                this.selectList = e;
                this.selectCount = e.length;
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
            delAll() {
                if (this.selectCount <= 0) {
                    this.$Message.warning("您还未选择要删除的数据");
                    return;
                }
                this.$Modal.confirm({
                    title: "确认删除",
                    content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
                    onOk: () => {
                        let ids = [];
                        this.selectList.forEach(function (e) {
                            ids.push(e.id);
                        });
                        delOffCourse(ids).then(res => {
                            if (res.status === true) {
                                this.$Message.success("删除成功");
                                this.clearSelectAll();
                                this.getDataList();
                            }
                        });
                    }
                });
            }
        },
        mounted() {
            this.init();
        }
    }
</script>
